import React from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import IndustriesSection from './components/IndustriesSection';
import TransformationSection from './components/TransformationSection';
import RoadmapSection from './components/RoadmapSection';
import TestimonialsSection from './components/TestimonialsSection';
import AuthorSection from './components/AuthorSection';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Modal from './components/Modal';

function App() {
  return (
    <div className="bg-pbi-black text-white font-sans antialiased overflow-x-hidden">
      <Navbar />
      <HeroSection />
      <IndustriesSection />
      <TransformationSection />
      <AuthorSection />
      <TestimonialsSection />
      <RoadmapSection />
      <Footer />
      <WhatsAppButton />
      <Modal />
    </div>
  );
}

export default App;